'use client';
import AmplienceDynamicComponent from 'components/amplience/dynamic-component';
import { ProductSearchProvider, useProductSearchContext } from './ProductSearchContext';
import PLPPlaceholder from 'components/amplience/plp-placeholder';
import Breadcrumb from 'components/commercetools-ui/molecules/Breadcrumb';
import { SortAttributes } from './components/ProductListSort';

const CategoryPlpContent = ({ data }: { data: any }) => {
  const searchContextValues = useProductSearchContext();
  const amplienceContent = data?.data?.data?.dataSource?.amplienceContent;
  const title = data?.data?.data?.dataSource?.category?.name || '';
  const categoryId = data?.data?.data?.dataSource?.category?.categoryId || '';
  const defaultColor = data?.data?.data?.dataSource?.defaultColor ?? undefined;

  const amplienceContentAndSearchContextValues = {
    ...amplienceContent,
    plpTitle: title,
    categoryId: categoryId,
    searchContextValues: searchContextValues,
  };
  const { productsPaginatedResults } = searchContextValues;
  const breadcrumbs = productsPaginatedResults?.data?.breadcrumbs || [];

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://shadesoflight.com',
      },
      ...breadcrumbs.map((breadcrumb: { label: string; slug: string }, index: number) => ({
        '@type': 'ListItem',
        position: index + 2,
        name: breadcrumb.label?.toLocaleLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()),
        item: 'https://shadesoflight.com/' + breadcrumb.slug,
      })),
    ],
  };

  return (
    <>
      {amplienceContent ? (
        <AmplienceDynamicComponent data={amplienceContentAndSearchContextValues} />
      ) : (
        <>
          <Breadcrumb structuredData={structuredData} breadcrumbs={breadcrumbs} />
          <PLPPlaceholder
            plpTitle={title}
            searchContextValues={searchContextValues}
            categoryId={categoryId}
            defaultColor={defaultColor}
          />
        </>
      )}
    </>
  );
};

const CategoryPLPTastic = (data: any) => {
  const defaultSortOption = data?.data?.data?.dataSource?.defaultSortFilter ?? '';
  const getDefaultSort = (key: string) => {
    switch (key) {
      case 'top-sellers':
        return SortAttributes[1];
      case 'new':
        return SortAttributes[2];
      case 'price-low-to-high':
        return SortAttributes[3];
      case 'price-high-to-low':
        return SortAttributes[4];
      default:
        return SortAttributes[0];
    }
  };
  return (
    <ProductSearchProvider customSort={getDefaultSort(defaultSortOption)}>
      <CategoryPlpContent data={data} />
    </ProductSearchProvider>
  );
};

export default CategoryPLPTastic;
